
import { defineComponent, ref, watch, onMounted, onUnmounted } from 'vue';
import * as monaco from 'monaco-editor';

export default defineComponent({
  name: 'MonacoEditor',
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          language: 'json',
        };
      },
    },
    value: {
      type: String,
      default: () => '',
    },
  },
  setup(props) {
    const refEditor = ref();
    let monacoEditor: monaco.editor.IStandaloneCodeEditor;

    const formatDocument = () => {
      monacoEditor.updateOptions({ readOnly: false });
      setTimeout(() => {
        monacoEditor.getAction('editor.action.formatDocument').run();
        setTimeout(() => {
          monacoEditor.updateOptions({ readOnly: true });
        }, 300);
      }, 300);
    };

    onMounted(() => {
      watch(
        () => props.value,
        (value) => {
          if (monacoEditor) {
            monacoEditor.setValue(value);
          } else {
            monacoEditor = monaco.editor.create(refEditor.value, {
              value,
              tabSize: 2,
              theme: 'vs-dark',
              automaticLayout: true,
              ...props.options,
            });
            // monacoEditor.onDidChangeModelContent(() => {
            //   console.log(monacoEditor.getValue());
            // });
          }
          formatDocument();
        },
        { immediate: true },
      );
    });

    onUnmounted(() => {
      monacoEditor?.dispose();
    });

    return {
      refEditor,
    };
  },
});
